import React, { useState, useEffect } from 'react';
import {
    List,
    Divider,
    Typography,
    Alert,
    Grid,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from '@mui/material';
import { supabase, host } from '../../../supabaseClient';
import moment from 'moment';
import { AccountCircle, Event, CheckCircle, RadioButtonUnchecked } from '@mui/icons-material';

const RewardsClaimsList = ({ companyId }) => {
    const [rewardsClaims, setRewardsClaims] = useState([]);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [selectedClaimId, setSelectedClaimId] = useState(null);
    const [selectedClaimIsClaimed, setSelectedClaimIsClaimed] = useState(false);

    const fetchRewardsClaims = async () => {
        try {
            const { data, error } = await supabase
                .from('rewards_claims')
                .select(`*, users(*), reward(*)`)
                .eq('company', companyId);

            if (error) {
                throw error;
            }
            setRewardsClaims(data);
        } catch (error) {
            console.error('Error fetching rewards claims:', error.message);
        }
    };

    useEffect(() => {
        fetchRewardsClaims();
    }, [companyId]);

    const handleClaimToggle = async (claimId, isClaimed) => {
        setSelectedClaimId(claimId);
        setSelectedClaimIsClaimed(isClaimed);
        setConfirmDialogOpen(true);
    };

    const handleConfirmClaimToggle = async () => {
        try {
            await supabase
                .from('rewards_claims')
                .upsert({ id: selectedClaimId, is_claimed: !selectedClaimIsClaimed });
            fetchRewardsClaims();
            setConfirmDialogOpen(false);
        } catch (error) {
            console.error('Error updating claim:', error.message);
        }
    };

    const handleCancelClaimToggle = () => {
        setConfirmDialogOpen(false);
    };

    if (rewardsClaims.length === 0) {
        return (
            <Alert severity="info" sx={{ mt: 2 }}>
                Aún no tienes solicitudes de canjeos.
            </Alert>
        );
    }

    return (
        <>
            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                {rewardsClaims.map((claim, index) => (
                    <React.Fragment key={index}>
                        <Grid container alignItems="center" spacing={1} sx={{ bgcolor: claim.is_claimed ? 'green' : 'inherit' }}>
                            <Grid item xs={3}>
                                <img
                                    src={`${host}/storage/v1/object/public/rewards/${companyId}/${claim.reward.id}.png`}
                                    alt={claim.reward}
                                    width="50"
                                    height="50"
                                />
                                <Typography variant="subtitle1">{claim.reward.name}</Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <AccountCircle />
                                {claim.users.name}
                            </Grid>
                            <Grid item xs={3}>
                                <Event />
                                {moment(claim.created_at).format('MMMM Do YYYY, h:mm:ss a')}
                            </Grid>
                            <Grid item xs={3}>
                                <IconButton onClick={() => handleClaimToggle(claim.id, claim.is_claimed)}>
                                    {claim.is_claimed ? <CheckCircle /> : <RadioButtonUnchecked />}
                                </IconButton>
                                Marcar como canjeado
                            </Grid>
                        </Grid>
                        <Divider light />
                    </React.Fragment>
                ))}
            </List>

            <Dialog open={confirmDialogOpen} onClose={handleCancelClaimToggle}>
                <DialogTitle>Confirmar reclamo</DialogTitle>
                <DialogContent>
                    <Typography variant="body1">
                        ¿Estás seguro de que deseas cambiar el estado del canjeo?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelClaimToggle}>Cancelar</Button>
                    <Button onClick={handleConfirmClaimToggle} variant="contained" color="primary">
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default RewardsClaimsList;
